import { MapfreIconComponent } from '../../individual-components/mapfre-icon/mapfre-icon.component';
import { MapfreButtonComponent } from '../../individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {  Component, HostListener, Input, OnInit, EventEmitter, Output, AfterContentInit , NO_ERRORS_SCHEMA }
  from '@angular/core';
import { ModalOptions } from '../../../_models/modal-options';
import { GTagService } from '../../../_services/g-tag.service';
import { AcmicService } from '../../../_services/acmic.service';
@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MapfreButtonComponent, MapfreIconComponent],
  selector: 'mapfre-modal',
  templateUrl: './mapfre-modal.component.html'
})
export class MapfreModalComponent implements OnInit, AfterContentInit {
  @Input() modalOptions: ModalOptions;
  @Input() hideModal: boolean;
  @Input() buttonString: string;
  @Input() loggedinHeaderModal: boolean;
  @Input() disabledValue: boolean;
  helpButtonPositionLeft: string;
  midHighResolution: boolean;
  modalTypeClasses: string;
  modalOverLay = true;
  responsiveSubtractAmount: number;
  size: string;
  closeIcon: string;

  @Output() hideModalOutput: EventEmitter<boolean> = new EventEmitter();
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  @Output() openModal: EventEmitter<boolean> = new EventEmitter();
  @Output() modalHide: EventEmitter<boolean> = new EventEmitter();
  isModalVisible = false;
  isAcmic = false;

  @HostListener('window:resize')
  onResize() {
    if (this.modalOptions.typeOfModal == 'header') {
      this.setUpModalClass();
    }
  }

  @HostListener('click')
  OnClick() {
    this.closeOnInternalButton(this.hideModal);
  }

  constructor(
    private gTagService: GTagService,
    private acmicService: AcmicService) {

  }

  private detectWindowWidth(width: number): string {
    let modalType: string;
    const breakPoints: any[] = [
      [320, 767, 'lowest'],
      [768, 991, 'mid'],
      [992, 1980, 'highest']
    ]
      ;
    for (const breakPoint of breakPoints) {
      if (width >= breakPoint[0] && width <= breakPoint[1]) {
        modalType = breakPoint[2];
      }
    }
    return modalType;
  }

  private setUpModalClass(): void {
    const modalWidth = this.detectWindowWidth(window.innerWidth);
    switch (modalWidth) {
      case 'lowest':
        this.modalOverLay = true;
        this.midHighResolution = false;
        // this.responsiveSubtractAmount = 260;
        this.responsiveSubtractAmount = 190;
        if (this.modalOptions.modalName === 'header_help_modal') {
          this.responsiveSubtractAmount = 260;
        }
        break;
      case 'mid':
        this.modalOverLay = true;
        this.midHighResolution = true;
        // this.responsiveSubtractAmount = 238;
        // this.responsiveSubtractAmount = 157;
        this.responsiveSubtractAmount = 10;
        if (this.modalOptions.modalName === 'header_help_modal') {
          this.responsiveSubtractAmount = 258;
        }
        break;
      case 'highest':
        this.modalOverLay = true;
        this.midHighResolution = true;
        // this.responsiveSubtractAmount = 170;
        // 1050px 962px
        // this.responsiveSubtractAmount = 70;
        this.responsiveSubtractAmount = 0;
        if (this.modalOptions.modalName === 'header_help_modal') {
          this.responsiveSubtractAmount = 170;
          // this.responsiveSubtractAmount = 180;
        }
        break;
      //add for larger screen size
      default:
        this.modalOverLay = true;
        this.midHighResolution = true;
        this.responsiveSubtractAmount = 170;
    }
  }

  checkIfModalAutoLoads(check): void {
    if (check) {
      this.modalOverLay = true;
      if (this.modalOptions.modalName) {
        this.gTagService.triggerPopupView(this.modalOptions.modalName);
      }
      setTimeout(() => {
        this.showModal();
      }, 500);

    }
  }

  closeOnInternalButton(hideModalEvent): void {
    if (hideModalEvent) {
      this.hide();
      this.hideModalOutput.emit(false);
    }
  }

  showModal(): void {
    this.isModalVisible = true;
  }

  hide(): void {
    if (this.isModalVisible) {
      this.isModalVisible = false;
      this.onModalHideEvent();
    }
  }

  onClickCloseModal() {
    console.log("modalClosed")
    this.closeModal.emit(true);
  }

  onOpenModalClick() {
    this.openModal.emit(true);
  }

  whereIsTheHelpButton(ref): void {
    if (this.modalOptions.modalName) {
      this.gTagService.triggerPopupView(this.modalOptions.modalName);
    }
    if (this.modalOptions.typeOfModal == 'header') {
      let leftPos = ref.currentTarget.offsetLeft;
      leftPos = leftPos - this.responsiveSubtractAmount;
      if (leftPos < 0) {
        leftPos = 0;
      }
      if (this.modalOptions.modalName === 'header_help_modal') {
        leftPos = leftPos - 30;
      }

      this.helpButtonPositionLeft = `${leftPos}px`;
    }
  }

  onModalHideEvent(){
    this.modalHide.emit(true);    
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.closeIcon = this.isAcmic ? './assets/img/images/icon-close-acmic-24.svg' : './assets/img/images/icon-close-24.svg'
    // if ( this.modalOptions.typeOfModal == 'header' ) {
    //   this.setUpModalClass();
    // }
    // this.checkIfModalAutoLoads( this.modalOptions.onLoad );
  }

  ngAfterContentInit() {
    if (this.modalOptions.typeOfModal == 'header') {
      this.setUpModalClass();
    }
    this.checkIfModalAutoLoads(this.modalOptions.onLoad);
  }

}
